import * as types from "./types";
import Cookies from "js-cookie";

const mutations = {
  [types.BEFORE_LOGIN](state) {
    Cookies.remove("loginToken");
    state.status = "loading";
  },
  [types.SET_TOKEN](state, payload) {
    // save in store
    state.token = payload;
    state.status = "success";
    // save in cookies
    Cookies.set("loginToken", payload, { expires: 600 });
  },
  [types.SET_USER_INFO](state, payload) {
    // save in store
    state.userInfo = payload;
  },
  [types.CLEAR_TOKEN](state) {
    state.token = "";
    state.status = "";
    Cookies.remove("loginToken");
  },
  [types.SHOW_TRANSLATION_ID](state) {
    state.showTranslationsId = !state.showTranslationsId;
  },
  [types.SHOW_ENGLISH_TOOLTIP](state) {
    state.showEnglishToolTip = !state.showEnglishToolTip;
  },
  [types.SET_IS_ADMIN](state, payload) {
    state.isAdmin = payload;
  },
  [types.SET_IS_DEBUG](state, payload) {
    state.isDebug = payload;
  },
  [types.SET_IS_UNILAB](state, payload) {
    state.isUnilab = payload;
  },
  [types.SET_CORDIVARI_ID](state, payload) {
    state.cordivariId = payload;
  }
};

export default mutations;
